import { TPhoto } from '@/interfaces/photos';

export function photoOrientation(photo?: TPhoto) {
  if (photo?.orientation) return photo?.orientation;

  if (!photo?.dimensions) return 'portrait';

  const [width, height] = photo?.dimensions.split('x').map((val) => Number(val));

  if (width === height) return 'square';

  return width > height ? 'landscape' : 'portrait';
}
